import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';


export function ApartmentDetailsModal({ apt_cat, setViewApartmentDetails, setDetailsModalId }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [images, setImages] = useState([])
  const [activeImage, setActiveImage] = useState(0);
  const [pageData, setPageData] = useState({});

  const prevImage = () =>
    setActiveImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));

  const nextImage = () =>
    setActiveImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  useEffect(() => {
    getData();
  }, [])
  const getData = async () => {
    const formData = new FormData();
    formData.append('apt_cat', apt_cat);

    setLoading(true)
    try {
        const response = await axios.post(base_url + '/apt-details.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setImages(response.data.images_arr);
            setPageData(response.data);
        } else {

        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-2 max-h-[80%] overflow-y-auto min-h-[100px] w-[90%] lg:w-[80%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div onClick={() => setViewApartmentDetails(false)} className='w-full px-4 flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                <div className="max-w-7xl mx-auto p-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* IMAGE GALLERY */}
                        <div className="relative">
                        <img
                            src={images[activeImage]}
                            alt="Room"
                            className="w-full h-[420px] object-cover rounded-lg"
                        />

                        {/* Navigation */}
                        <button
                            onClick={prevImage}
                            className="absolute flex items-center justify-center h-10 w-10 left-3 top-1/2 -translate-y-1/2 bg-white/90 rounded-full shadow"
                        >
                            <FaChevronLeft size={15} />
                        </button>
                        <button
                            onClick={nextImage}
                            className="absolute flex items-center justify-center h-10 w-10 right-3 top-1/2 -translate-y-1/2 bg-white/90 rounded-full shadow"
                        >
                            <FaChevronRight size={15} />
                        </button>

                        {/* Thumbnails */}
                        <div className="flex gap-2 mt-3 overflow-x-auto">
                            {images.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                onClick={() => setActiveImage(index)}
                                className={`h-16 w-24 object-cover rounded cursor-pointer border ${
                                activeImage === index
                                    ? "border-[#003a41]"
                                    : "border-gray-200"
                                }`}
                            />
                            ))}
                        </div>
                        </div>

                        {/* ROOM DETAILS */}
                        <div>
                        <h1 className="text-2xl font-semibold mb-3">{pageData?.apartment_category}</h1>

                        {/* Feature chips */}
                        <div className="flex flex-wrap gap-2 mb-4">
                            {pageData?.amenities_arr?.map((item) => (
                            <span
                                key={item}
                                className="border border-gray-300 rounded-md px-3 py-1 text-sm"
                            >
                                {item}
                            </span>
                            ))}
                        </div>

                        <p className="text-sm text-gray-700 mb-4">
                            {pageData?.apartment_desc}
                        </p>

                        {/* ROOM INFO */}
                        <div className="space-y-4">
                            <div>
                            <h3 className="font-semibold mb-2">In your private bathroom:</h3>
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                                {[
                                "Bathtub",
                                "Shower",
                                "Free toiletries",
                                "Toilet",
                                "Towels",
                                "Slippers",
                                "Hairdryer",
                                "Toilet paper",
                                ].map((item) => (
                                <li key={item}>✓ {item}</li>
                                ))}
                            </ul>
                            </div>

                            <div>
                            <h3 className="font-semibold mb-2">Facilities:</h3>
                            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                                {[
                                "Air conditioning",
                                "Safe",
                                "Hardwood floors",
                                "Desk",
                                "Sitting area",
                                "Refrigerator",
                                "Electric kettle",
                                "Satellite channels",
                                "Wake-up service",
                                "Wardrobe or closet",
                                ].map((item) => (
                                <li key={item}>✓ {item}</li>
                                ))}
                            </ul>
                            </div>

                            <p className="text-sm">
                            <strong>Smoking:</strong> No smoking
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>  
        </div>
    )
}

